import React from "react";
import { NikoFacilityOrderStatusBarTemplate } from "themes/application/niko-facility-order/components";
import { NikoFacilityOrderStatusBarViewStore } from 'application/niko-facility-order/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderStatusBarViewStore(rootStore, componentProps), 'nikoFacilityOrderStatusBarViewStore')
@observer
class NikoFacilityOrderStatusBar extends React.Component {
	render() {
		return <NikoFacilityOrderStatusBarTemplate {...this.props} />;
	}
}

export default NikoFacilityOrderStatusBar;